module.exports = __webpack_public_path__ + "static/media/logo_red.54af802b.svg";